import * as yup from 'yup';
import UserFormRolesData from '../../models/user-form-roles-data';
type TFunction = (key: string, options?: Record<string, unknown>) => string;
export const initialUserFormRole: UserFormRolesData = {
  userRolesEnterprise: null,
  userRolesEstablishment: null,
};

export const userFormRoleSchema = (translate: TFunction) => {
  return yup.object().shape({
    userRolesEnterprise: yup
      .object()
      .optional()
      .nullable()
      .shape({
        enterpriseId: yup.string().required(translate('REQUIRED')),
        role: yup.string().required(translate('REQUIRED')),
      }),
    userRolesEstablishment: yup
      .array()
      .nullable()
      .optional()
      .of(
        yup.object().shape({
          enterpriseId: yup.string().required(translate('REQUIRED')),
          establishmentId: yup.string().required(translate('REQUIRED')),
          role: yup.string().required(translate('REQUIRED')),
        }),
      ),
  });
};
